import { PessoaPagamentoModel } from "model/api/gestao/pessoa/pessoa-pagamento-model";
import { CardNaoEncontrado } from "views/components/cards";
import { CardPessoaPagamento } from "views/components/cards/card-pessoa-pagamento/card-pessoa-pagamento";
import { InformacaoIcon } from "views/components/icons";

export interface ClienteSocioGridProps {
  list: Array<PessoaPagamentoModel>;
  carregando: boolean;
  selectedList: Array<string>;
  onCardSelected: (model: PessoaPagamentoModel) => void;
  onCardChecked: (id: string) => any;
}

export const RevendedorPagamentoListData = (props: ClienteSocioGridProps) => {

  const onCardSelected = (model: PessoaPagamentoModel) => {
    props.onCardSelected(model);
  };

  const onCardChecked = (id: string) => {
    props.onCardChecked(id);
  };

  return (
    <>
      {props.list.length === 0 && !props.carregando && (
        <CardNaoEncontrado
          mensagem="Nenhuma Forma de Pagamento vinculada."
          icon={<InformacaoIcon tipo="GERAL" />}
        />
      )}
      {props?.list.length > 0 &&
        props.list.map((items, index) => {
          return (
            <CardPessoaPagamento
              selected={
                props.selectedList.filter((item) => item === items.id).length >
                  0
                  ? true
                  : false
              }
              onCheck={onCardChecked}
              onClick={onCardSelected}
              model={items}
              key={index}
            />
          );
        })}
    </>
  );
};
